const Icon = (props) => {
    return (
        <svg width={18} height={18} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M5.44444 1V3.66667C5.44444 4.13816 5.25714 4.59035 4.92375 4.92375C4.59035 5.25714 4.13816 5.44444 3.66667 5.44444H1M17 5.44444H14.3333C13.8618 5.44444 13.4097 5.25714 13.0763 4.92375C12.7429 4.59035 12.5556 4.13816 12.5556 3.66667V1M12.5556 17V14.3333C12.5556 13.8618 12.7429 13.4097 13.0763 13.0763C13.4097 12.7429 13.8618 12.5556 14.3333 12.5556H17M1 12.5556H3.66667C4.13816 12.5556 4.59035 12.7429 4.92375 13.0763C5.25714 13.4097 5.44444 13.8618 5.44444 14.3333V17"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />{' '}
        </svg>
    );
};

export default Icon;
